import React, { useRef, useState } from "react";
import { useMotionValueEvent, useScroll } from "framer-motion";

import { css, keyframes } from "@emotion/css";
import ArrowIcon from "../../../img/svg/home/step-two/arrow.svg";
import ArrowBottomIcon from "../../../img/svg/home/step-tree/arrow.svg";

import IMG11 from "../../../img/png/home/step-two/1-1.png";
import IMG12 from "../../../img/png/home/step-two/1-2.png";
import IMG21 from "../../../img/png/home/step-two/2-1.png";
import IMG21Girl from "../../../img/png/home/step-two/2-1-girl.png";
import IMG22 from "../../../img/png/home/step-two/2-2.png";
import IMG22Girl from "../../../img/png/home/step-two/2-2-girl.png";
import IMG22Boy from "../../../img/png/home/step-two/2-2-boy.png";
import IMG31 from "../../../img/png/home/step-two/3-1.png";
import IMG31Face from "../../../img/png/home/step-two/3-1-face.png";
import IMG31Sun from "../../../img/svg/home/step-two/3-1-sun.svg";
import IMG31SunFace from "../../../img/svg/home/step-two/3-1-sun-face.svg";
import IMG32 from "../../../img/png/home/step-two/3-2.png";
import IMG32Girl from "../../../img/png/home/step-two/3-2-girl.png";
import IMG33 from "../../../img/png/home/step-two/3-3.png";
import IMG33Item from "../../../img/png/home/step-two/3-3-item.png";

import El1 from "../../../img/png/home/step-tree/el1.png";
import El2 from "../../../img/png/home/step-tree/el2.png";
import El3 from "../../../img/png/home/step-tree/el3.png";
import El4 from "../../../img/png/home/step-tree/el4.png";
import El5 from "../../../img/png/home/step-tree/el5.png";
import El6 from "../../../img/png/home/step-tree/el6.png";
import El7 from "../../../img/png/home/step-tree/el7.png";
import El8 from "../../../img/png/home/step-tree/el8.png";
import El9 from "../../../img/png/home/step-tree/el9.png";
import StepTreeBG from "../../../img/png/home/step-tree/bg.png";
import StepTreeBGMobile from "../../../img/png/home/step-tree/bg-mobile.png";

import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import { useI18n } from "../../../i18n";

const StepTwo = () => {
  const ref = useRef(null);
  const { scrollY } = useScroll();
  const [slide, setSlide] = useState(1);
  const { t } = useI18n();

  useMotionValueEvent(
    scrollY,
    "change",
    (latest) => {
      const value =
        (100 * (latest - ref.current.offsetTop)) / ref.current.clientHeight;

      if (value > 60) {
        setSlide(5);
      } else if (value > 45) {
        setSlide(4);
      } else if (value > 30) {
        setSlide(3);
      } else if (value > 15) {
        setSlide(2);
      } else if (value > 5) {
        setSlide(1);
      } else {
        setSlide(0);
      }
    },
    []
  );

  return (
    <div
      style={{
        background: "#000",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
      }}
      ref={ref}
    >
      <div className={`${style.step2} ${slide > 0 ? "active" : "inactive"}`}>
        <img src={ArrowIcon} alt="" />
        <h5>{t("home_step2_step")}</h5>
        <h3>{t("home_step2_personalise")}</h3>
        <p>
          {t("home_step2_personalise_body1")}
          <br />
          <br />
          {t("home_step2_personalise_body2")}
        </p>
      </div>
      <div className={style.animationStep2}>
        <div className={`item i12 ${slide > 0 ? "active" : "inactive"}`}>
          <img src={IMG12} className="bg" alt="" />
        </div>
        <div className={`item i11 ${slide > 0 ? "active" : "inactive"}`}>
          <img src={IMG11} className="bg" alt="" />
        </div>
        <div className={`item i21 ${slide > 1 ? "active" : "inactive"}`}>
          <img src={IMG21} className="bg" alt="" />
          <img src={IMG21Girl} className="el girl" alt="girl" />
        </div>
        <div className={`item i22 ${slide > 1 ? "active" : "inactive"}`}>
          <img src={IMG22} className="bg" alt="" />
          <img src={IMG22Girl} className="el girl" alt="girl" />
          <img src={IMG22Boy} className="el boy" alt="boy" />
        </div>
        <div className={`item i33 ${slide > 2 ? "active" : "inactive"}`}>
          <img src={IMG33} className="bg" alt="" />
          <img src={IMG33Item} className="el" alt="item" />
        </div>
        <div className={`item i32 ${slide > 2 ? "active" : "inactive"}`}>
          <img src={IMG32} className="bg" alt="" />
          <img src={IMG32Girl} className="el" alt="girl" />
        </div>
        <div className={`item i31 ${slide > 3 ? "active" : "inactive"}`}>
          <img src={IMG31} className="bg" alt="" />
          <div className="sun-wrapper">
            <img src={IMG31Sun} className="sun" alt={t("about_alt_sun")} />
            <img src={IMG31SunFace} className="sun-face" alt="sun face" />
          </div>
          <img src={IMG31Face} className="face" alt={t("tech_face_alt_face")} />
        </div>
      </div>
      <div
        className={`${style.step2} ${style.step3} ${
          slide > 3 ? "active" : "inactive"
        }`}
      >
        <div className="wrapper">
          <img src={ArrowBottomIcon} alt="" />
          <h5>{t("home_step3_step")}</h5>
          <h3>{t("home_step3_serving")}</h3>
          <p>
            {t("home_step3_serving_body")}
          </p>
        </div>
      </div>

      <div className={`${style.animationStep2} ${style.animationStep3}`}>
        <div className={`item i4 ${slide > 4 ? "active" : "inactive"}`}>
          <div className="wrapper">
            <img src={El1} className="in el1" alt="" />
            <img src={El2} className="in el2" alt="" />
            <img src={El3} className="in el3" alt="" />
            <img src={El4} className="in el4" alt="" />
            <img src={El5} className="in el5" alt="" />
            <img src={El6} className="in el6" alt="" />
            <img src={El7} className="in el7" alt="" />
            <img src={El8} className="in el8" alt="" />
            <img src={El9} className="el9" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

const rotate = (reverse = false) =>
  keyframes({
    "0%": {
      transform: `rotate(0deg)`,
    },
    "60%": {
      transform: `rotate(${reverse ? 100 : -100}deg)`,
    },
    "100%": {
      transform: `rotate(${reverse ? 90 : -90}deg)`,
    },
  });

const bounce = (bounce = 15, reverse = false) =>
  keyframes({
    "0%": {
      transform: `translateY(0px)`,
    },
    "40%": {
      transform: `translateY(${reverse ? "-" : ""}${bounce}px)`,
    },
    "100%": {
      transform: `translateY(0px)`,
    },
  });

const bounceInfinit = (bounce = 15, reverse = false) =>
  keyframes({
    "0%": {
      transform: `translateY(0px)`,
    },
    "50%": {
      transform: `translateY(${reverse ? "" : "-"}${bounce}px)`,
    },
    "100%": {
      transform: `translateY(0px)`,
    },
  });

const style = {
  animationStep3: css({
    height: "auto !important",
    maxWidth: "100% !important",
    margin: "auto",

    ".item": {
      right: 0,
      left: 0,
      margin: "cover",
      width: "100%",
      height: 1100,
      zIndex: 1,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top center",
      backgroundSize: "auto",
      backgroundImage: `url(${StepTreeBG})`,
      overflow: "unset !important",
      maxWidth: "100%",

      ".wrapper": {
        maxWidth: 1412,
        width: "100%",
        height: "100%",
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
        display: "block",
      },

      "&.active": {
        bottom: 0,
        animationName: `${bounce(15, true)}`,
      },
      "&.inactive": {
        bottom: -300,
        animationName: `${bounce()}`,
      },
      ".in": {
        animationName: `${bounceInfinit()}`,
        animationIterationCount: "infinite",
        animationDuration: "6s",
        position: "absolute",
        zIndex: 2,
        height: "auto",
        opacity: 0.9,
        maxHeight: 96,
      },
      ".el1": {
        bottom: 210,
        left: "2%",
      },
      ".el2": {
        bottom: 320,
        left: "22%",
      },
      ".el3": {
        bottom: 190,
        left: "27%",
        animationName: `${bounceInfinit(15, true)}`,
      },
      ".el4": {
        bottom: 80,
        left: "47%",
      },
      ".el5": {
        bottom: 310,
        left: "40%",
        animationName: `${bounceInfinit(15, true)}`,
      },
      ".el6": {
        bottom: 220,
        left: "50%",
        animationName: `${bounceInfinit(15, true)}`,
        zIndex: 2,
      },
      ".el7": {
        bottom: 140,
        right: "12%",
        animationName: `${bounceInfinit(15, true)}`,
        zIndex: 1,
      },
      ".el8": {
        bottom: 220,
        right: "2%",
        zIndex: 1,
      },
      ".el9": {
        position: "absolute",
        top: "9%",
        left: "29%",
        maxHeight: 96,
      },
    },
    [desktop]: {
      marginTop: "-200px",

      ".item": {
        height: 900,
        backgroundSize: "1400px",

        ".wrapper": {
          maxWidth: 1000,
          marginTop: 80,
        },

        ".in, .el9": {
          width: "auto",
          maxHeight: 80,
        },
        ".el9": {
          position: "absolute",
          top: "0",
          left: "29%",
        },
      },
    },
    [laptop]: {
      marginTop: "-100px",
      paddingBottom: 400,

      ".item": {
        height: 1400,
        backgroundSize: "800px",
        backgroundImage: `url(${StepTreeBGMobile})`,

        ".wrapper": {
          maxWidth: 700,
          marginTop: 80,
        },
        ".el9": {
          top: "2%",
          left: "10%",
        },
        ".in, .el9": {
          width: "auto",
          maxHeight: 80,
        },
        ".el1": {
          bottom: 580,
          left: "10%",
        },
        ".el2": {
          bottom: 720,
          left: "5%",
        },
        ".el3": {
          bottom: 190,
          left: "unset",
          right: "5%",
        },
        ".el4": {
          bottom: 250,
          left: "5%",
        },
        ".el5": {
          bottom: 650,
          left: "unset",
          right: "5%",
        },
        ".el6": {
          bottom: 480,
          left: "unset",
          right: "1%",
        },
        ".el7": {
          bottom: 340,
          right: "5%",
        },
        ".el8": {
          bottom: 400,
          right: "unset",
          zIndex: 1,
          left: "5%",
        },
      },
    },
    [tablet]: {
      marginTop: "80px",
      ".item": {
        height: 1000,
        backgroundSize: "580px",
        paddingBottom: 0,

        "&.i4": {
          bottom: "-100px",
          backgroundSize: 500,
        },
        "&.i21": {
          top: "520px",
        },
        ".wrapper": {
          maxWidth: 440,
          marginTop: 0,
        },

        ".in, .el9": {
          width: "auto",
          height: 60,
        },
        ".el9": {
          position: "absolute",
          top: "0",
          left: "19%",
          height: 60,
        },
        ".el1": {
          bottom: 390,
          left: "10%",
        },
        ".el2": {
          bottom: 470,
          left: "5%",
        },
        ".el3": {
          bottom: 170,
          left: "unset",
          right: "5%",
        },
        ".el4": {
          bottom: 200,
          left: "5%",
        },
        ".el5": {
          bottom: 420,
          left: "unset",
          right: "5%",
        },
        ".el6": {
          bottom: 330,
          left: "unset",
          right: "1%",
        },
        ".el7": {
          bottom: 250,
          right: "5%",
        },
        ".el8": {
          bottom: 290,
          right: "unset",
          zIndex: 1,
          left: "5%",
        },
      },
    },
  }),
  animationStep2: css({
    maxWidth: 1412,
    width: "100%",
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
    height: "2700px",

    ".item": {
      position: "absolute",
      transition: "all 1s",
      overflow: "hidden",

      "&.active": {
        animationDelay: "0s",
        animationDuration: "2s",
        animationName: `${bounce()}`,

        ".el": {
          animationDelay: "0s",
          animationDuration: "2s",
          animationName: `${bounce()}`,
        },
      },
      "&.inactive": {
        animationDelay: "0s",
        animationDuration: "2s",
        animationName: `${bounce(15, true)}`,

        ".el": {
          animationDelay: "0s",
          animationDuration: "2s",
          animationName: `${bounce(15, true)}`,
        },
      },
      ".bg": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1,
      },
      ".el": {
        position: "absolute",
        zIndex: 2,
        transition: "all 2s",
      },
    },

    ".i12": {
      right: 0,
      top: -150,
      width: 333,
      height: 467,
      zIndex: 3,

      "&.active": {
        top: 0,
        animationName: `${bounce(40)}`,
      },
    },
    ".i11": {
      right: 333,
      top: 400,
      width: 491,
      height: 253,
      zIndex: 3,

      "&.active": {
        top: 214,
      },
    },

    ".i22": {
      right: 0,
      top: 867,
      width: 824,
      height: 460,
      zIndex: 2,

      "&.active": {
        top: 467,
        animationName: `${bounce(15, true)}`,

        ".el": {
          animationName: `${bounce(15, true)}`,

          "&.girl": {
            right: 0,
            bottom: 0,
          },
          "&.boy": {
            left: 0,
            bottom: 0,
          },
        },
      },
      "&.inactive": {
        animationName: `${bounce()}`,

        ".el": {
          animationName: `${bounce()}`,

          "&.girl": {
            right: 0,
            bottom: -200,
          },
          "&.boy": {
            left: 0,
            bottom: -200,
          },
        },
      },
    },
    ".i21": {
      right: 824,
      top: 767,
      width: 576,
      height: 718,
      transitionDelay: ".5s",
      zIndex: 2,

      "&.active": {
        top: 467,
        animationDelay: "1.5s",
        animationName: `${bounce(15, true)}`,

        ".el": {
          bottom: 0,
          animationDelay: "1.5s",
          transitionDelay: ".5s",
          animationName: `${bounce(15, true)}`,
        },
      },
      "&.inactive": {
        animationDelay: "1.5s",
        animationName: `${bounce()}`,

        ".el": {
          bottom: -200,
          animationDelay: "1.5s",
          transitionDelay: ".5s",
          animationName: `${bounce()}`,
        },
      },
    },

    ".i33": {
      right: 0,
      top: 1327,
      width: 464,
      height: 469,
      zIndex: 1,
      borderBottomRightRadius: 200,
      borderBottomLeftRadius: 200,

      "&.active": {
        top: 927,
        animationName: `${bounce(15, true)}`,

        ".el": {
          bottom: 0,
          animationName: `${bounce(15, true)}`,
        },
      },
      "&.inactive": {
        animationName: `${bounce()}`,

        ".el": {
          bottom: -200,
          animationName: `${bounce()}`,
        },
      },
    },
    ".i32": {
      right: 464,
      top: 1427,
      width: 360,
      height: 640,
      transitionDelay: ".5s",
      zIndex: 1,
      borderBottomRightRadius: 200,

      "&.active": {
        top: 927,
        animationDelay: "1.5s",
        animationName: `${bounce(15, true)}`,

        ".el": {
          bottom: 0,
          animationDelay: "1.5s",
          transitionDelay: ".5s",
          animationName: `${bounce(15, true)}`,
        },
      },
      "&.inactive": {
        animationDelay: "1.5s",
        animationName: `${bounce()}`,

        ".el": {
          bottom: -200,
          animationDelay: "1.5s",
          transitionDelay: ".5s",
          animationName: `${bounce()}`,
        },
      },
    },
    ".i31": {
      right: 824,
      top: 1478,
      width: 576,
      height: 660,
      transitionDelay: ".5s",
      zIndex: 1,
      borderBottomRightRadius: 200,

      ".sun-wrapper": {
        position: "absolute",
        bottom: 200,
        right: -60,
        zIndex: 2,

        ".sun": {
          width: "100%",
          height: "100%",
          position: "relative",
          zIndex: 1,
        },
        ".sun-face": {
          position: "absolute",
          zIndex: 2,
          display: "block",
          margin: "auto",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        },
      },

      ".face": {
        position: "absolute",
        bottom: "-50px",
        right: "-50px",
        zIndex: 3,
        opacity: 0.8,
      },

      "&.active": {
        top: 1178,
        animationDelay: "1.5s",
        animationName: `${bounce(15, true)}`,

        ".sun-wrapper": {
          ".sun": {
            animationDelay: "1s",
            animationDuration: "2s",
            animationName: `${rotate(true)}`,
          },
        },
      },
      "&.inactive": {
        animationDelay: "1.5s",
        animationName: `${bounce()}`,

        ".sun-wrapper": {
          ".sun": {
            animationDelay: "1s",
            animationDuration: "2s",
            animationName: `${rotate()}`,
          },
        },
      },
    },
    [desktop]: {
      maxWidth: 1000,
      height: "2300px",

      ".i12": {
        right: 0,
        top: -200,
        width: 243.566,
        height: 341.577,
      },
      ".i11": {
        right: 243.566,
        top: 400,
        width: 359.131,
        height: 185.051,

        "&.active": {
          top: 156,
        },
      },

      ".i22": {
        right: 0,
        top: 567,
        width: 602.697,
        height: 336.457,

        "&.active": {
          top: 341.577,
        },

        ".el": {
          "&.girl": {
            width: "auto",
            height: 336.457,
          },
          "&.boy": {
            width: "auto",
            height: 336.457,
          },
        },
      },
      ".i21": {
        right: 602.697,
        top: 567,
        width: 421.303,
        height: 525.166,

        ".el": {
          "&.girl": {
            width: "auto",
            height: 454.217,
          },
        },
        "&.active": {
          top: 341.577,
        },
      },

      ".i33": {
        right: 0,
        top: 878,
        width: 339.383,
        height: 343.04,
        ".el": {
          width: "auto",
          height: 343.04,
        },
        "&.active": {
          top: 678,
        },
      },
      ".i32": {
        right: 339.383,
        top: 878,
        width: 263.314,
        height: 468.114,
        ".el": {
          width: "auto",
          height: 468.11,
        },
        "&.active": {
          top: 678,
        },
      },
      ".i31": {
        right: 602.697,
        top: 1066.743,
        width: 421.303,
        height: 482.743,

        "&.active": {
          top: 866.743,
        },
        ".sun-wrapper": {
          position: "absolute",
          bottom: 150,
          right: -60,
          zIndex: 2,
          width: 200,
          height: 200,
        },

        ".face": {
          bottom: "-30px",
          right: "-30px",
          width: 274,
          height: 273.989,
        },
      },
    },
    [laptop]: {
      height: "2900px",
      maxWidth: 744,
      marginLeft: "auto",
      marginRight: "auto",

      ".i12": {
        right: 0,
        top: 0,
        width: 301.889,
        height: 423.37,
      },
      ".i11": {
        right: 301.889,
        width: 442.114,
        height: 227.81,

        "&.active": {
          top: 195,
        },
      },

      ".i22": {
        right: 0,
        top: 723.37,
        width: 744,
        height: 414.201,

        "&.active": {
          top: 423.37,
        },
      },
      ".i21": {
        left: 0,
        right: "unset",
        top: 1038,
        width: 454,
        height: 564,

        "&.active": {
          top: 838,
        },
      },

      ".i33": {
        right: 0,
        top: 1038,
        width: 290.406,
        height: 293.536,
        borderRadius: 0,
        background: "#7600FF",

        ".el": {
          width: "auto",
          height: 320,
          left: -50,
        },
        "&.active": {
          top: 838,
          ".el": {
            bottom: -50,
          },
        },
      },
      ".i32": {
        right: 0,
        top: 1330,
        width: 290.406,
        height: 516.278,

        ".el": {
          width: "auto",
          height: 516.28,
          right: 0,
        },
        "&.active": {
          top: 1130,
        },
      },
      ".i31": {
        right: "unset",
        left: 0,
        top: 1600,
        width: 453,
        height: 519.063,

        "&.active": {
          top: 1400,
        },

        ".sun-wrapper": {
          bottom: 180,
          right: -50,
        },

        ".face": {
          bottom: "-30px",
          right: "-40px",
        },
      },
    },
    [tablet]: {
      height: "1900px",
      maxWidth: 375,
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: 50,

      ".i12": {
        right: 0,
        top: -0,
        width: 151.132,
        height: 211.947,
      },
      ".i11": {
        right: 151.132,
        width: 222.84,
        height: 114.824,
        top: 197,

        "&.active": {
          top: 97,
        },
      },

      ".i22": {
        top: 311.947,
        width: 375,
        height: 208.77,

        "&.active": {
          top: 211.947,
        },
        ".el": {
          "&.girl": {
            width: "auto",
            height: 208.77,
          },
          "&.boy": {
            width: "auto",
            height: 208.77,
          },
        },
      },
      ".i21": {
        left: 0,
        right: "unset",
        top: 570,
        width: 375,
        height: 466,

        "&.active": {
          top: 420,
        },
        ".el": {
          "&.girl": {
            width: "auto",
            height: 403.283,
          },
        },
      },

      ".i33": {
        right: "unset",
        left: 0,
        top: 1038,
        width: 224.606,
        height: 227.027,
        borderRadius: 0,
        background: "#7600FF",

        ".el": {
          width: "auto",
          height: 227.027,
          left: -50,
        },
        "&.active": {
          top: 886,
          ".el": {
            bottom: -50,
          },
        },
      },
      ".i32": {
        right: 0,
        left: "unset",
        top: 1038,
        width: 150.533,
        height: 267.361,

        ".el": {
          width: "auto",
          height: 267.361,
          right: 0,
        },
        "&.active": {
          top: 886,
        },
      },
      ".i31": {
        right: "unset",
        left: 0,
        top: 1238,
        width: 224.606,
        height: 257.361,
        borderBottomRightRadius: 80,

        "&.active": {
          top: 1110,
        },

        ".sun-wrapper": {
          position: "absolute",
          bottom: 60,
          right: -30,
          zIndex: 2,
          width: 97.892,
          height: 97.877,

          ".sun-face": {
            width: 40,
            height: 40,
          },
        },

        ".face": {
          bottom: "-10px",
          right: "-10px",
          width: 106.844,
          height: 106.84,
        },
      },
    },
  }),
  step2: css({
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center ",
    alignItems: "flex-start",
    paddingTop: 200,
    maxWidth: 1412,
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: 60,
    overflow: "hidden",

    width: "100%",

    "&.active": {
      animationDelay: "1s",
      animationDuration: "2s",
      animationName: `${bounce()}`,
    },
    "&.inactive": {
      animationDelay: "1s",
      animationDuration: "2s",
      animationName: `${bounce(15, true)}`,
    },

    h5: {
      color: "#fff",
      fontFamily: "Syne",
      fontSize: 52,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "98%",
      marginBottom: 12,
    },
    h3: {
      color: "#fff",
      fontFamily: "Syne",
      fontSize: 78,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "100%",
      textTransform: "uppercase",
      marginBottom: 104,
    },
    p: {
      color: "#fff",
      fontFamily: "Inter",
      fontSize: 18,
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      letterSpacing: 0.36,
      maxWidth: 785,
    },
    img: {
      position: "absolute",
      top: 78,
      right: 30,
      width: "auto",
      height: "auto",
      zIndex: 0,
    },
    [desktop]: {
      h5: {
        fontSize: 48,
        maxWidth: 610,
      },
      h3: {
        fontSize: 64,
        marginBottom: 42,
        maxWidth: 610,
      },
      p: {
        marginLeft: 0,
        maxWidth: 610,
      },
      img: {
        right: 100,
        width: 157.257,
        height: 104.594,
      },
    },
    [laptop]: {
      paddingLeft: 40,
      h5: {
        fontSize: 52,
        maxWidth: 600,
      },
      h3: {
        fontSize: 72,
        marginBottom: 42,
        maxWidth: 600,
      },
      p: {
        marginLeft: 0,
        fontSize: 20,
        maxWidth: 600,
      },
      img: {
        width: 181.989,
        height: 121.044,
        right: 100,
      },
    },
    [tablet]: {
      marginLeft: 20,
      marginRight: 20,
      paddingLeft: 0,
      paddingTop: 100,
      width: "auto",

      h5: {
        fontSize: 26,
        wordBreak: "break-all",
      },
      h3: {
        fontSize: 40,
        marginBottom: 20,
        wordBreak: "break-all",
      },
      p: {
        marginLeft: 0,
        fontSize: 14,
        maxWidth: 320,
      },
      img: {
        width: 109.667,
        height: 72.941,
        right: 0,
        top: 30,
      },
    },
  }),
  step3: css({
    alignItems: "flex-end",
    paddingLeft: 0,
    transition: "all 2s",

    ".wrapper": {
      maxWidth: 490,
      marginLeft: 60,
      marginRight: 60,
    },

    "&.active": {
      bottom: 1100,
    },
    "&.inactive": {
      bottom: 800,
    },
    h3: {
      marginBottom: 20,
    },
    img: {
      position: "absolute",
      top: -90,
      right: 30,
      width: "auto",
      height: "auto",
      zIndex: 1,
    },
    p: {
      marginLeft: 0,
    },
    [desktop]: {
      alignItems: "center",

      ".wrapper": {
        maxWidth: 630,
        marginLeft: 30,
        marginRight: 30,
      },

      img: {
        right: "15%",
      },
      h5: {
        fontSize: 48,
        textAlign: "center",
      },
      h3: {
        fontSize: 64,
        marginBottom: 20,
        textAlign: "center",
      },
      p: {
        textAlign: "center",
      },
    },
    [laptop]: {
      alignItems: "flex-start",

      ".wrapper": {
        maxWidth: 630,
        marginLeft: 30,
        marginRight: 30,
      },

      img: {
        right: "15%",
        top: "2%",
        width: 252,
        height: 275.269,
      },
      h5: {
        fontSize: 52,
        textAlign: "left",
      },
      h3: {
        fontSize: 72,
        marginBottom: 42,
        textAlign: "left",
        maxWidth: 450,
      },
      p: {
        textAlign: "left",
        fontSize: 20,
        maxWidth: 600,
      },
    },
    [tablet]: {
      overflow: "unset",
      ".wrapper": {
        maxWidth: 336,
        marginLeft: 0,
        marginRight: 0,
      },

      "&.active": {
        bottom: 480,
      },
      "&.inactive": {
        bottom: 480,
      },

      img: {
        right: 0,
        top: -100,
        width: 143.728,
        height: 157,
      },
      h5: {
        fontSize: 26,
      },
      h3: {
        fontSize: 42,
        marginBottom: 20,
        maxWidth: 220,
        wordBreak: "none",
      },
      p: {
        fontSize: 14,
        maxWidth: 300,
      },
    },
  }),
};

export default StepTwo;
